// extracted by mini-css-extract-plugin
export default {"projects":"ListProjects_projects__f9SLg","sectionTitle":"ListProjects_sectionTitle__YHceD"};